import { OrderEditingSettingsSchema } from "@redotech/redo-order-editing-common/order-editing-tools";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

export const getAllowedOrderEditTypes = {
  name: "getAllowedOrderEditTypes" as const,
  input: z.object({ orderId: zExt.objectId() }),
  output: OrderEditingSettingsSchema.optional(),
};
